var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import LoginForm from '../../components/Login/LoginForm';
import messages from './messages';
import commonMessages from '../../message.common';
import injectIntl from '../../utils/injectIntl';
import * as rootActions from '../Root/actions';
import { makeSelectUser } from '../Root/selectors';
import AppspotrWhiteLogo from '../../images/logos/appspotrWhite.svg';
import { P } from '../../components/UI-helpers/typography';
import { LoginImage, LoginDetails, LoginPageWrapper, LoginImageWrapper, LoginPageContainer, } from './styles';
var LoginPage = function (_a) {
    var intl = _a.intl, user = _a.user, onLogin = _a.onLogin;
    var location = useLocation();
    var navigate = useNavigate();
    var pathname = location.pathname, search = location.search;
    var _b = (location.state || {}).from, from = _b === void 0 ? { pathname: '/' } : _b;
    // Redirect if user is authenticated and not coming from the root path
    if (user.token && from.pathname !== '/') {
        return _jsx(Navigate, { to: from.pathname, replace: true });
    }
    var isPrivacy = pathname.includes('/privacy');
    var isTerms = pathname.includes('/terms');
    var isTokenExpired = pathname.includes('/token');
    var welcomeMessage = '';
    if (isPrivacy) {
        welcomeMessage = 'You have declined our Privacy Policies';
    }
    else if (isTerms) {
        welcomeMessage = 'You have declined our Terms & Conditions';
    }
    else if (isTokenExpired) {
        welcomeMessage = 'Your session has expired, please log in again';
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: intl.formatMessage(__assign({}, commonMessages.login)) }), _jsx("meta", { name: "description", content: intl.formatMessage(__assign({}, messages.header)) })] }), _jsx(LoginPageContainer, { children: _jsxs(LoginPageWrapper, { children: [_jsx(LoginImageWrapper, { children: _jsx(LoginImage, { src: AppspotrWhiteLogo, alt: "" }) }), _jsx(LoginDetails, { children: _jsx(P, __assign({ fontSize: 16, bold: true, white: true }, { children: "Log into your account" })) }), _jsx(LoginForm, { user: user, onLogin: function (incomingProps) { return onLogin(__assign(__assign({}, incomingProps), { navigate: navigate })); }, onForgotPassword: function () { return navigate('/password-reset'); }, urlParam: search, welcomeMessage: welcomeMessage, isPrivacy: isPrivacy, isTerms: isTerms, isTokenExpired: isTokenExpired })] }) })] }));
};
var mapStateToProps = createStructuredSelector({
    user: makeSelectUser(),
});
var mapDispatchToProps = function (dispatch) { return ({
    onLogin: function (_a) {
        var email = _a.email, password = _a.password, code = _a.code, urlParam = _a.urlParam, navigate = _a.navigate;
        dispatch(rootActions.login(email, password, code, urlParam, navigate));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default injectIntl(withConnect(LoginPage));
